import axios from "./AxiosInstance"

const getAllProfessionalHealth = (patientId) =>
    axios.get(`api/healthProfessionals?patientId=${patientId}&isExternal=1&paginated=false`)

const postNewProfessionalHealthAgreement = ({ payload, patientId }) => {
    console.log({ payload, patientId })
    return axios.post(`api/patients/${patientId}/healthProfessionals/accept`, { ...payload })
}

export const PatientFollowUpService = {
    getAllProfessionalHealth,
    postNewProfessionalHealthAgreement
}
